import {
    USER_DETAILS,
    UG_CREATE_SUCCESS,
    UG_CREATE_FAILURE,
    UG_ERROR_RESET,
    USER_INVITED
} from '../actions/types';

const initialState = {
    renderAccName: false,
    avatarUrl: '',
    firstName: '',
    lastName: '',
    email: '',
    id: '',
    accName: '',
    inviterName: '',
    isUserInvited: false
};

function userDetails(state, action) {
    if (typeof state === 'undefined') {
        return initialState;
    }

    switch (action.type) {
        case USER_DETAILS:
        case UG_CREATE_SUCCESS:
        case USER_INVITED:
        case UG_CREATE_FAILURE: {
            const { payload } = action;
            return { ...state, ...payload };
        }
        case UG_ERROR_RESET:
            return { ...state, submitError: false }
        default:
            return state;
    }
}

export default userDetails;
